export const MARGIN_BEFORE_FOOTER = 8;
